/** Derive follow-up context from recent assistant chat messages. */

export function extractLastTeacherFromMessages(messages) {
  const list = Array.isArray(messages) ? messages : [];
  for (let i = list.length - 1; i >= 0; i -= 1) {
    const m = list[i];
    if (m?.role !== "assistant") continue;

    const profileTeacher = m.teacherProfile?.teacher || m.storyTeacher;
    if (profileTeacher?.id || profileTeacher?.name || profileTeacher?.reg) {
      return {
        id: profileTeacher.id || null,
        name: profileTeacher.name || null,
        reg: profileTeacher.reg || profileTeacher.registration || null,
      };
    }

    const firstResult = m.teacherResults?.[0];
    if (firstResult?.id || firstResult?.name) {
      return {
        id: firstResult.id || null,
        name: firstResult.name || null,
        reg: firstResult.reg || null,
      };
    }
  }
  return null;
}

/** Last assistant message that included a teacher profile card (for quick follow-ups). */
export function extractLastTeacherProfileFromMessages(messages) {
  const list = Array.isArray(messages) ? messages : [];
  for (let i = list.length - 1; i >= 0; i -= 1) {
    const m = list[i];
    if (m?.role !== "assistant") continue;
    if (m.teacherProfile?.teacher) return m.teacherProfile;
  }
  return null;
}

/** Assistant asked for leave type + dates before preview. */
export function isAwaitingLeaveDetails(messages) {
  const list = Array.isArray(messages) ? messages : [];
  for (let i = list.length - 1; i >= 0; i -= 1) {
    const m = list[i];
    if (m?.role === "user") return false;
    if (m?.role === "assistant" && m.commandDraft?.awaiting === "leave_details") {
      return true;
    }
  }
  return false;
}

export function extractPendingLeaveDraft(messages) {
  const list = Array.isArray(messages) ? messages : [];
  for (let i = list.length - 1; i >= 0; i -= 1) {
    const m = list[i];
    if (m?.role === "user") return null;
    if (m?.role === "assistant" && m.commandDraft?.awaiting === "leave_details") {
      return m.commandDraft;
    }
  }
  return null;
}

/** Assistant just asked the user for a teacher name or matricule. */
export function isAwaitingTeacherSearchName(messages) {
  const list = Array.isArray(messages) ? messages : [];
  for (let i = list.length - 1; i >= 0; i -= 1) {
    const m = list[i];
    if (m?.role === "user") return false;
    if (m?.role === "assistant") {
      const content = String(m.content || "");
      return (
        m.type === "search" ||
        /look up any teacher|retrouver une enseignante|name or matricule|nom ou matricule|indiquez un nom|provide a name/i.test(
          content
        )
      );
    }
  }
  return false;
}

export function buildConversationHistory(messages, limit = 6) {
  const list = Array.isArray(messages) ? messages : [];
  return list
    .filter((m) => m?.role === "user" || m?.role === "assistant")
    .slice(-limit)
    .map((m) => ({
      role: m.role === "user" ? "user" : "assistant",
      content: String(m.content || "")
        .replace(/\*\*/g, "")
        .slice(0, 600),
    }))
    .filter((m) => m.content.length > 0);
}
